@switch (currentView) {
  @case(views.Home) {
    <div class="container">
      <button (click)="getModoEdicion()" class="request-button">Ver Modo edición</button>

      <button (click)="getEditado()" class="request-button">Ver si el oráculo está Editado</button>
    </div>

    <div class="container">
      <button (click)="getSecondsIntervalUpdates(true)" class="request-button">Ver frecuencia de actualización</button>

      <button (click)="selectView(views.ModifyFrequency)" class="request-button ">Modificar frecuencia de actualización</button>
    </div>

    @if (globalService.editing) {
      <div class="container">
        <button (click)="selectView(views.Comparison)" class="request-button">Ver cambios</button>
      </div>
    }
  }

  <!-- Vista de modificar frecuencia -->
  @case(views.ModifyFrequency) {
    <div class="edit-frequency-container">
      <h4>Editar frecuencia de actualización</h4>

      <input type="number" [(ngModel)]="secondsFrequency" class="input-seconds" placeholder="Segundos">

      <div class="edit-frequency-buttons">
        <button class="back-button button-colors" (click)="selectView(views.Home)">Volver</button>

        <button class="modify-button button-colors" (click)="updateSecondsIntervalUpdates()" [disabled]="!globalService.editing || (!secondsFrequency || secondsFrequency <= 0)">Confirmar</button>
      </div>
    </div>
  }

  <!-- Vista de comparación de modo actual con edición -->
  @case(views.Comparison) {
    <div class="search-container compare-backups-title-container">
      <p class="compare-backups-title">Comparación de versión actual del Oráculo con el modo edición</p>

      <button class="button button-colors" (click)="selectView(views.Home)">Volver</button>
    </div>

    <div class="scroll-container">
      @if (!backupComparisonInProgress) {
        @if (backupComparison !== '') {
          <div class="comparison-container" [innerHTML]="backupComparison"></div>
        } @else {
          <p class="no-changes-text">No hay cambios</p>
        }
      }
    </div>
  }
}